import { notifyAdapter } from '@/features/messages/adapters/notify-adapter'
import { pbPermissions } from './adapters/pb-permissions'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { PermissionPort } from './domain/permission'

const permissions: PermissionPort = pbPermissions

const notify: NotifyPort = notifyAdapter

export { permissions, notify }
